<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Agreement List"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name='Agreement List' [columns]="displayedColumns" (filterChange)="onFilterChange($event)">
        <div class="actions">
          <button class="create"  type="button" [routerLink]="['/customer-agreement/create-customer-agreement']" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource">
  
            <ng-container matColumnDef="agreementNumber">
              <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
              <td mat-cell *matCellDef="let element">
                {{ element.agreementNumber}}
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let element">
                <button [routerLink]="['/customer-agreement/customer-detail',  element.agreementNumber]">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount }" class="clickable route-animations-elements" mat-row></tr>
          </table>
          <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No customer agreement found.
        </div>
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig] = "selectConfig"
          [ngClass]="{'mat-pegig': pageSize === 9999}"
          aria-label="Select page of periodic elements">
      </mat-paginator>
      
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  




